import React from "react"

const SourceStatusButton = ({ active }) => (
    <div className={`btn source-status btn-${active ? "active" : "inactive"}`}>
        {active ? "Active" : "Inactive"}
    </div>
)

export default SourceStatusButton
